//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'
import 'devextreme/ui/button'
import 'devextreme/ui/popup'
import 'devextreme/ui/popover'
import 'devextreme/ui/scroll_view'

//#endregion

import { i18n } from '../i18n/common.i18n'
import { DetailsScope } from '../common.details'

import { GridOptions, GridTypes } from '../../common/grid/grid.controller'

import { Enums } from '../../../models/common'
import { EventsNames, PopupManager, RequestManager, TypeHelper, IUserSession, TemplateHelper, ConfigHelper, LocalizationHelper } from '../../../helpers'

import { DetailsPopupTabSelectedArgs } from './details-popup.interfaces'

//#region Asset Imports

import './details-popup.scss'
import * as TEMPLATE from './details-popup.tpl.html'

//#endregion

export interface DetailsOptions {
    /**
     * @deprecated Don't use, its unnecessary
     */
    hasPermission?: boolean

    idReferenceType?: Enums.ReferenceType,
    moduleName?: Enums.SimaxModuleName

    activeTab?: string
    activeAccordion?: string
    pageItems?: any[],
    pageItemsIds?: number[],
    referenceObject?: any,
    referenceObjectId?: number
}

interface DetailsPopupScope extends DetailsScope {
    popupId: number

    deleteMethod(): void
    hidePopup(clickedCloseButton: boolean): void
    popupName: string

    popupOptions: DevExpress.ui.dxPopupOptions
    closeButtonOptions: DevExpress.ui.dxButtonOptions
    prevButtonOptions: DevExpress.ui.dxButtonOptions
    nextButtonOptions: DevExpress.ui.dxButtonOptions
    deleteButtonOptions: DevExpress.ui.dxButtonOptions
    accordionsButtonOptions: DevExpress.ui.dxButtonOptions
    refreshButtonOptions: DevExpress.ui.dxButtonOptions

    accordionPopoverOptions: DevExpress.ui.dxPopoverOptions
    accordionPopoverVisible: boolean
    accordionIsUnknownReferenceTable: boolean

    accordionGrid: DevExpress.ui.dxDataGrid
    accordionGridOptions: GridOptions

    nextEntityId(): number
    prevEntityId(): number
    groupsEditSource: any
    isUserDetails: boolean

    getOptions(): DetailsPopupOptions

    actionPopoverVisible: boolean
    actionPopoverOptions: DevExpress.ui.dxPopoverOptions
    actionButtonVisible: boolean
    actionButtonOptions: DevExpress.ui.dxButtonOptions
    actions: DevExpress.ui.dxButtonOptions[]

    scrollViewOptions: DevExpress.ui.dxScrollViewOptions

    checkAccordionsButtonVisible: () => boolean
}

export interface DetailsPopupOptions {
    id: number
    deleteMethod?: any
    delHasPermissions?: string
    title: string
    contentTitle?: string
    openEventName: string
    closeEventName: string
    visiblePopup?: boolean
    modelId?: any
    items?: any[]
    popupId?: string
    getAccordionDataMethod(): any[]
    updateAccordionMethod?: any
    getAccordionSelectionMethod?: any
    actions?: DevExpress.ui.dxButtonOptions[]
    getLevel?: () => number
    refreshButton?: () => void

    onTabSelected?: (e: DetailsPopupTabSelectedArgs) => void
}

// global
var VISIBLE_POPUP_COUNT = 0

export class DetailsPopupDirective implements ng.IDirective {
    restrict = 'E'

    controller = ['$scope', '$attrs', '$timeout', 'userSession', (
        $scope: DetailsPopupScope,
        $attrs: ng.IAttributes,
        $timeout: ng.ITimeoutService,
        userSession: IUserSession
    ) => {
        $scope.popupId = $scope.$id

        $scope.$on(EventsNames.DETAILS_ACTIONS_UPDATED, (event, ...args) => {
            $scope.actionButtonVisible = $scope.options.actions && $scope.options.actions.length > 0
        })

        $scope.requestsStates = {}
        var popupManager = PopupManager.getInstance()

        $scope.getOptions = () => {
            return $scope[$attrs['options']] ? $scope[$attrs['options']] : <DetailsPopupOptions>{}
        }

        $scope.scrollViewOptions = {
            disabled: false,
        }

        let cancelAllRequests = () => {
            _.mapObject($scope.requestsStates, (val, key) => {
                if (val.request && !val.request.$resolved)
                    RequestManager.cancelRequest(val)
            })
        }

        var closeEvent: () => void = null

        $scope.popupOptions = {
            fullScreen: false,
            height: () => {
                return 'calc(100% - 33px)'
            },
            width: '100%',
            showCloseButton: true,
            dragEnabled: false,
            bindingOptions: {
                visible: 'getOptions().visiblePopup'
            },
            onInitialized: (e) => {
                $scope.popup = e.component
            },
            onShown: (e) => {
                $scope.$emit(EventsNames.OPENED_POPUP)
                popupManager.add($scope.popup)

                VISIBLE_POPUP_COUNT++
                var popupNumber = VISIBLE_POPUP_COUNT
                closeEvent = $scope.$on(EventsNames.ESC_KEY_PRESS, () => {
                    if (VISIBLE_POPUP_COUNT == popupNumber) {
                        if ($scope.popupOptions) {
                            $timeout(() => {
                                closeDetails(null)
                            })
                        }
                    }
                })
            },
            onHidden: (e) => {
                $scope.visiblePopup = false
                $scope.$emit(EventsNames.CLOSED_POPUP, true)

                // !!!TODO zmiana nazwy
                $scope.$emit(EventsNames.CLOSED_POPUP + 'New', $scope['id'])

                popupManager.deleteAndFocusLastPopup()
                cancelAllRequests()
                if (closeEvent)
                    closeEvent()
                VISIBLE_POPUP_COUNT--
            },
            position: {
                at: 'top',
                my: 'top'
            }
        }

        $scope.nextEntityId = (): number => {
            const openDetailsParams = $scope.detailsOpenParams

            popupManager.focusOnCurrent()

            if (openDetailsParams) {
                if (openDetailsParams.pageItemsIds) {
                    const entityIds = openDetailsParams.pageItemsIds

                    if (entityIds.length === 1) {
                        return null
                    }

                    const nextIdx = entityIds.indexOf($scope.getOptions().modelId)

                    return entityIds[nextIdx + 1] || null
                } else if (openDetailsParams.pageItems) {
                    const entities = openDetailsParams.pageItems

                    if (entities.length === 1) {
                        return null
                    }

                    const currentIdx = _.findIndex(entities, (entity: any) => TypeHelper.getId(entity) === $scope.getOptions().modelId)
                    const nextEntity = entities[currentIdx + 1]

                    return nextEntity ? TypeHelper.getId(nextEntity) : null
                }
            } else if ($scope.getOptions().items) {
                const itemIds = $scope.getOptions().items

                if (itemIds.length === 1) {
                    return null
                }

                const index = itemIds.indexOf($scope.getOptions().modelId)

                return itemIds[index + 1] || null
            }

            return null
        }


        $scope.prevEntityId = (): number => {
            const openDetailsParams = $scope.detailsOpenParams

            popupManager.focusOnCurrent()

            if (openDetailsParams) {
                if (openDetailsParams.pageItemsIds) {
                    const entityIds = openDetailsParams.pageItemsIds

                    if (entityIds.length === 1) {
                        return null
                    }

                    const nextIdx = entityIds.indexOf($scope.getOptions().modelId)

                    return entityIds[nextIdx - 1] || null
                } else if (openDetailsParams.pageItems) {
                    const entities = openDetailsParams.pageItems

                    if (entities.length === 1) {
                        return null
                    }

                    const currentIdx = _.findIndex(entities, (entity: any) => TypeHelper.getId(entity) === $scope.getOptions().modelId)
                    const nextEntity = entities[currentIdx - 1]

                    return nextEntity ? TypeHelper.getId(nextEntity) : null
                }
            } else if ($scope.getOptions().items) {
                const itemIds = $scope.getOptions().items

                if (itemIds.length === 1) {
                    return null
                }

                const index = itemIds.indexOf($scope.getOptions().modelId)

                return itemIds[index - 1] || null
            }

            return null
        }

        var nextEntity = () => {
            $scope.$emit(EventsNames.CLOSED_POPUP)

            const nextId = $scope.nextEntityId()

            if (nextId) {
                const openDetailsParams = $scope.detailsOpenParams

                if (openDetailsParams) {
                    const paramsCopy = _.clone(openDetailsParams)

                    if (openDetailsParams.pageItemsIds) {
                        paramsCopy.referenceObjectId = nextId

                        $scope.$root.$broadcast($scope.getOptions().openEventName + $scope.getOptions().id.toString(), null, null, null, paramsCopy)
                    } else if (openDetailsParams.pageItems) {
                        paramsCopy.referenceObject = _.find(openDetailsParams.pageItems, (item: any) => TypeHelper.getId(item) === nextId)

                        $scope.$root.$broadcast($scope.getOptions().openEventName + $scope.getOptions().id.toString(), null, null, null, paramsCopy)
                    }
                } else {
                    $scope.$root.$broadcast($scope.getOptions().openEventName + $scope.getOptions().id.toString(), nextId, $scope.getOptions().items)
                }
            }
        }

        var prevEntity = () => {
            $scope.$emit(EventsNames.CLOSED_POPUP)
            var prevId = $scope.prevEntityId()

            if (prevId) {
                const openDetailsParams = $scope.detailsOpenParams

                if (openDetailsParams) {
                    const paramsCopy = _.clone(openDetailsParams)

                    if (openDetailsParams.pageItemsIds) {
                        paramsCopy.referenceObjectId = prevId

                        $scope.$root.$broadcast($scope.getOptions().openEventName + $scope.getOptions().id.toString(), null, null, null, paramsCopy)
                    } else if (openDetailsParams.pageItems) {
                        paramsCopy.referenceObject = _.find(openDetailsParams.pageItems, (item: any) => TypeHelper.getId(item) === prevId)

                        $scope.$root.$broadcast($scope.getOptions().openEventName + $scope.getOptions().id.toString(), null, null, null, paramsCopy)
                    }
                } else {
                    $scope.$root.$broadcast($scope.getOptions().openEventName + $scope.getOptions().id.toString(), prevId, $scope.getOptions().items)
                }
            }
        }

        var closeDetails = (clickedCloseButton) => {
            if ($scope.getOptions().getLevel && $scope.getOptions().getLevel() > 1) {
                $scope.$emit(EventsNames.CLOSED_POPUP, true)
                return
            }
            $scope.getOptions().visiblePopup = false

            if ($scope.getOptions().closeEventName) {
                $scope.$emit($scope.getOptions().closeEventName + $scope.getOptions().id.toString())
            }

            $scope.$broadcast(EventsNames.STOP_MEASUREMENTS_LOADING)
        }

        var isRTL = $scope.$root['rtlState']

        $scope.closeButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, userSession),
            onClick: closeDetails,
            hint: i18n('Popup', 'Close')
        }

        $scope.prevButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.PREV, userSession),
            onClick: isRTL ? nextEntity : prevEntity,
            bindingOptions: {
                disabled: isRTL ? '!nextEntityId()' : '!prevEntityId()'
            },
            hint: isRTL ? i18n('Popup', 'Next') : i18n('Popup', 'Previous')
        }

        $scope.nextButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.NEXT, userSession),
            onClick: isRTL ? prevEntity : nextEntity,
            bindingOptions: {
                disabled: isRTL ? '!prevEntityId()' : '!nextEntityId()'
            },
            hint: isRTL ? i18n('Popup', 'Previous') : i18n('Popup', 'Next')
        }

        $scope.deleteButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, userSession),
            onClick: $scope.getOptions().deleteMethod,
            hint: i18n('Popup', 'Delete')
        }

        $scope.refreshButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.REFRESH, userSession),
            onClick: $scope.getOptions().refreshButton,
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Refresh)
        }

        $scope.accordionPopoverVisible = false
        $scope.accordionIsUnknownReferenceTable = true

        var accordionPopover: DevExpress.ui.dxPopover
        $scope.accordionsButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ACCORDION, userSession),
            onClick: (e) => {
                $scope.accordionPopoverVisible = !$scope.accordionPopoverVisible
                if ($scope.accordionPopoverVisible) {
                    accordionPopover.show()
                    getAccordionGridData()
                }
                else {
                    accordionPopover.hide()
                    $('.dx-button').blur()
                }
            },
            hint: i18n('Popup', 'SelectedAccordions')
        }

        $scope.checkAccordionsButtonVisible = () => {
            if (!$scope.getOptions().getAccordionDataMethod) {
                return false
            } else {
                const data: any[] = $scope.getOptions().getAccordionDataMethod()
                if ($scope.showMobileCloseButton) {
                    return true
                }
                if (_.size(data) < 2) {
                    return false
                }
            }
            return true
        }

        $scope.accordionPopoverOptions = {
            width: 300,
            onInitialized: (e) => {
                accordionPopover = e.component
            },
            target: '#accordionsButton' + $scope.popupId,
            bindingOptions: {
                visible: 'accordionPopoverVisible'
            },
            onHiding: () => {
                $scope.accordionPopoverVisible = false
            },
            onHidden: () => {
                $scope.accordionIsUnknownReferenceTable = true
            }
        }

        var getAccordionGridData = () => {
            var columns = [
                {
                    dataField: "name",
                    caption: i18n('Common', 'Name'),
                    dataType: "string"
                }
            ] as DevExpress.ui.dxDataGridColumn[]

            var data = $scope.getOptions().getAccordionDataMethod()
            var selection = $scope.getOptions().getAccordionSelectionMethod()

            var dataSourceOptions = {
                store: new ArrayStore({
                    data: data,
                    key: 'value'
                })
            }
            var dataSource = new DataSource(dataSourceOptions)

            var accorionOnSelectionChangedTimeout
            $scope.accordionGridOptions = {
                name: null,
                idReferenceType: Enums.ReferenceType.None,
                onInitialized: (e) => {
                    $scope.accordionGrid = e.component
                },
                type: GridTypes.SMALL,
                buttonsOptions: {
                    enabled: false,
                },
                addCustomFilters: false,
                columns: columns,
                showColumnHeaders: false,
                showColumnLines: false,
                showRowLines: false,
                onSelectionChanged: (e) => {
                    if (accorionOnSelectionChangedTimeout) clearTimeout(accorionOnSelectionChangedTimeout)
                    accorionOnSelectionChangedTimeout = setTimeout(() => {
                        $scope.getOptions().updateAccordionMethod(e.selectedRowsData.map(val => val.value))
                    }, 500)
                },
                allowColumnReordering: false,
                filterRow: {
                    visible: false
                },
                selectedRowKeys: selection,
                selection: {
                    mode: 'multiple',
                    showCheckBoxesMode: 'always'
                },
                dataSource: dataSource,
                height: 'max'
            }

            if (data && data.length > 0) {
                $scope.accordionIsUnknownReferenceTable = false
            }
            else {
                $scope.accordionIsUnknownReferenceTable = true
            }
        }

        $scope.actions = $scope.getOptions().actions
        if ($scope.actions) {
            var actionPopover: DevExpress.ui.dxPopover
            $scope.actionPopoverOptions = {
                width: 'auto',
                onInitialized: (e) => {
                    actionPopover = e.component
                },
                target: '#detailsPopupActionsButton' + $scope.popupId,
                bindingOptions: {
                    visible: 'actionPopoverVisible'
                },
                onHiding: () => {
                    $scope.actionPopoverVisible = false
                }
            }
            $scope.actionButtonOptions = {
                template: TemplateHelper.getIcon(ConfigHelper.Icon.DETAILS_POPUP_ACTIONS_BUTTON, userSession),
                onClick: (e) => {
                    $scope.actionPopoverVisible = !$scope.actionPopoverVisible
                    if ($scope.actionPopoverVisible) actionPopover.show()
                    else actionPopover.hide()
                },
                bindingOptions: {
                    visible: 'actions.length > 0'
                },
                hint: i18n('Popup', 'Actions')
            }

            $scope.actions.forEach(a => {
                // add popover hide
                a['actionOnClick'] = a.onClick
                a.onClick = () => {
                    a['actionOnClick']()
                    $scope.actionPopoverVisible = false
                    actionPopover.hide()
                }
            })
            $scope.isUserDetails = $scope.getOptions().openEventName == "event:openUserDetailsPopup" ? true : false
            $scope.actionButtonVisible = $scope.actions.length > 0 || $scope.isUserDetails


            $scope.$watchCollection('actions', (newButtons: DevExpress.ui.dxButtonOptions[]) => {
                if (newButtons) {
                    newButtons.forEach((button: DevExpress.ui.dxButtonOptions) => {
                        if (!('actionOnClick' in button)) {
                            button['actionOnClick'] = button.onClick
                            button.onClick = () => {
                                button['actionOnClick']()
                                $scope.actionPopoverVisible = false
                                actionPopover.hide()
                            }
                        }
                    })
                }
            })
        }
    }]

    template = TEMPLATE
    replace = true
    transclude = true
}